import Mixpanel from 'mixpanel-browser';
import { MIXPANEL_TOKEN } from 'config';

function noop() {}

var mixpanel: any = {
  init: noop,
  track: noop,
  register: noop,
  reset: noop,
};

export function initMixpanel() {
  if (MIXPANEL_TOKEN) {
    Mixpanel.init(MIXPANEL_TOKEN);
    mixpanel = Mixpanel;
  }
}

export function track(name: string, props?: Record<string, unknown>) {
  mixpanel.track(name, props);
}

export function register(name: string, props?: Record<string, unknown>) {
  mixpanel.register(name, props);
}

export function reset() {
  mixpanel.reset();
}
